<af-main-container [title]="'i18n_af_titleAnalytics' | translate"
                   [showBreadcrumbs]="false"
                   [showBackButton]="false"
                   [buttonLabel]="showTrendDownloadReportButton && ('i18n_af_buttonDownloadReport' | translate)"
                   (buttonClickListener)="buttonClickSubject.next(activeTab)">

    @if (showRunNewTrendAnalysisButton) {
        <div CustomButtons fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
            <ui-kit-button type="secondary" class="mr-16"
                [label]="'i18n_af_buttonGenerateTrend' | translate"
                (clickListener)="generateNewTrendAnalysis()"/>
        </div>
    }

    <mat-tab-group mat-align-tabs="start" animationDuration="0"
                   fxFlex
                   class="mt-16 w-100 h-100 overflow-y-scroll"
                   [(selectedIndex)]="selectedTabIndex"
                   (selectedIndexChange)="handleNavigation($event)">
        @for (tab of tabs; track tab) {
            <mat-tab [label]="'i18n_af_' + tab | translate" class="text-center h-100"
                     [disabled]="disabledTabs.includes(tab)">
                <ng-template matTabContent>
                    @if (tab === 'tabTrends') {
                        <af-analytic-trends [buttonClickStream]="buttonClickSubject"/>
                    } @else {
                        <div class="container mt-32">
                            @for (panel of tabsViewModel[tab]; track panel) {
                                <af-action-panel
                                    fxFlexAlign="stretch"
                                    [viewModel]="panel"/>
                            }
                        </div>
                    }
                </ng-template>
            </mat-tab>
        }
    </mat-tab-group>

</af-main-container>
